import asyncComponent from '../../components/AsyncComponent';

const Courses = asyncComponent(() => import('../../containers/Course/CourseList'));

export default Courses;
